interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors cursor-pointer";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${baseBtn} gap-1 border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={`${baseBtn} ${
            page === current
              ? "bg-primary-600 text-background-50"
              : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${baseBtn} gap-1 border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}